import { ICreateWatchState } from './createWatchContext';
import { CreateWatchActionTypes, TCreateWatchAction } from './createWatchActions';

export const createWatchReducer = (state: ICreateWatchState, action: TCreateWatchAction): ICreateWatchState => {
	switch (action.type) {
		case CreateWatchActionTypes.CHANGE_SERIAL_NUMBER:
			return {
				...state,
				serialNumber: action.payload.serialNumber,
			};
		case CreateWatchActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
			};
		case CreateWatchActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
			};
		case CreateWatchActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateWatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateWatchActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CreateWatchActionTypes.RESET_FIELDS:
			return {
				...state,
				serialNumber: '',
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
